export const Actiontypes = {
    PROFILE:"PROFILE",
    WINDOWS:"WINDOWS",
  };
  